import Cookie from 'js-cookie';
import { DEFAULT_FLOW_ID } from 'src/config/flowConfig';
import appConfig from 'src/utils/appConfig';
import { post } from 'axios';

const pickStatus = ({ status }) => ({ status });

const getTrackingUUID = () => Cookie.get('babbeltrackinguuid');

const declareReporter = (level) => (body, rawPayload) => {
  const { rollbarApiToken, rollbarApiUrl, environment } = appConfig.getMyConfig();
  const browserString = navigator.userAgent;
  const payload = Object.assign({}, rawPayload, {
    trackingUuid: getTrackingUUID()
  });

  return post(rollbarApiUrl, {
    access_token: rollbarApiToken,
    data: {
      level,
      environment,
      platform: 'browser',
      client: { javascript: { browser: browserString } },
      body: { message: { body, payload } }
    }
  }).then(pickStatus, pickStatus);
};

const reportError = declareReporter('error');
const reportWarning = declareReporter('warning');

export const reportUncaughtException = (message, url, lineNumber, columnNumber, error) =>
  reportError(message, {
    url,
    lineNumber,
    columnNumber,
    stack: error ? error.stack : undefined
  });

export const reportAPIFailure = ({ error, verb, path, body }) =>
  reportError('api:call:failed', { error, verb, path, body });

export const reportTrackerFailure = (error, eventName, payload) =>
  reportError('tracker:failed', {
    eventName,
    payload,
    error: {
      message: error.message || error,
      status: error.status,
      readyState: error.readyState
    }
  });

export const reportRegistrationFailure = (error, statusCode) =>
  reportError('registration:failed', { error, statusCode });

/**
 * Reports failures on AB Tester. If the error contains customData
 * it will attach it as the payload.
 *
 * customData is attached by ab-tester.api.js
 */
export const reportAbTesterFailure = (error) => {
  const payload = Object.assign({}, error.customData);
  return reportError('ab-tester:call:failed', { error, payload });
};

export const reportFlowServiceFailure = (rawError, flowId, url) => {
  const error =  { message: rawError.message || rawError || 'Undefined error message' };
  const report = flowId === DEFAULT_FLOW_ID ? reportError : reportWarning;
  report(`CDN:loading:flow:failed:${flowId}`, { error, url });
};

export const reportStrategyError = ({ strategyType, id }) => {
  reportError('strategy:failed', {
    strategyType,
    flowID: id,
    trackingUuid: getTrackingUUID()
  });
};
